module.exports = __webpack_public_path__ + "img/9.1bb4833a.png";